export enum CoreStorageKeys {
  cashRegister = "cashRegisterId",
  accessToken = "access_token",
  expiresAt = "expires_at",
  expiresIn = "expires_in"
}
